"use client";

import type { ComponentProps } from "react";
import { LandvestHandoffLink } from "@/components/layout/LandvestHandoffLink";
import { track, type HomepageHeroCtaClickedProperties } from "@/lib/analytics";

type HeroCtaLinkProps = ComponentProps<typeof LandvestHandoffLink> &
  Pick<HomepageHeroCtaClickedProperties, "card" | "action">;

/**
 * A link in a homepage hero card that reports its click. HeroSection stays a
 * server component; only the links hydrate. The event names the unresolved
 * route, so the seller's analysis link reads as the hand-off route and not as
 * the LandVest URL it resolves to.
 */
export function HeroCtaLink({ card, action, href, onClick, ...props }: HeroCtaLinkProps) {
  return (
    <LandvestHandoffLink
      href={href}
      onClick={(event) => {
        track.homepageHeroCtaClicked({ card, action, destination: href });
        onClick?.(event);
      }}
      {...props}
    />
  );
}
